import { ChangeDetectorRef, Directive } from "@angular/core";
import { BaseTimelineComponent } from "../timeline/base-timeline.component";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { IProjectAOI } from "../../../../interfaces/i-project-aoi";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Directive()
export abstract class DummyTimelineComponent extends BaseTimelineComponent {
  protected constructor(
    public googleAnalyticsService: GoogleAnalyticsService,
    public cdr: ChangeDetectorRef,
    public flagService: FeatureFlagsService,
  ) {
    super(googleAnalyticsService, cdr, flagService);
  }

  get aois(): IProjectAOI[] {
    return [];
  }

  getLegend(value: number): string {
    return "";
  }

  onChangeProject(value: number) {}

  updateSliderValue() {}
}
